<div class="grid max-h-10rem overflow-y-auto date-grid">
  <div
    *ngFor="let dateOption of availableDates; let i = index"
    class="col-3 date-grid-item"
    (click)="onSelectDate(dateOption.date)"
  >
    <div
      class="border-round-lg px-4 py-2 flex flex-column align-items-center hover:bg-gray-100 cursor-pointer"
      [ngClass]="{
        'bg-blue-50 border-blue-400 border-2 text-blue-500': isSameDay(
          dateOption.date,
          selectedDate
        ),
        'bg-white border-gray-400 border-1': !isSameDay(dateOption.date, selectedDate)
      }"
    >
      <p class="bold-text m-0">{{ dateOption.date | datex : 'ddd' }}</p>
      <p class="mt-1 mb-0">{{ dateOption.date | datex : 'Do MMM' }}</p>
    </div>
  </div>
</div>
